import { Validators, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Component } from '@angular/core';
import { Observable, of, } from 'rxjs';
import { map, tap, switchMap } from 'rxjs';
import { ConfigSection } from '../config-section';
import { GeneralInformation } from '@admin/models/system-configuration-model';
import { RouteContextService } from '@context/services/route-context.service';
import { SystemConfigurationHttpService } from '@admin/services/system-configuration-http.service';
import { SystemConfigurationService } from '@admin/services/system-configuration.service';

@Component({
  selector: 'mojo-mojo-general-information',
  templateUrl: './general-information.component.html'
})
export class GeneralInformationComponent extends ConfigSection<GeneralInformation> {

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly activatedRoute: ActivatedRoute,
    private readonly routeContextService: RouteContextService,
    private readonly systemConfigService: SystemConfigurationService,
    private readonly systemConfigHttpService: SystemConfigurationHttpService
  ) { super(); }

  initialiseConfig(): Observable<GeneralInformation> {
    return this.systemConfigHttpService.getSystemConfiguration(this.getProduct())
      .pipe(
        switchMap(info => {
          info.applicationName = 'Mojo';
          return of(info);
        })
      );
  }

  createForm(brandInfo: GeneralInformation): void {
    this.form = this.formBuilder.group({
      applicationName: [{ value: 'Mojo', disabled: true }, [Validators.required, Validators.maxLength(150)]],
      supportTelNo: [brandInfo.supportTelNo, [Validators.required, Validators.maxLength(100)]],
      emailSignature: [brandInfo.emailSignature, [Validators.required, Validators.maxLength(250)]],
      supportEmailAddress: [brandInfo.supportEmailAddress, [Validators.maxLength(150)]],
      companyWebSite: [brandInfo.companyWebSite, [Validators.maxLength(150)]],
    });
  }

  submit(): Observable<boolean> {
    const brandInfo: GeneralInformation = this.form.getRawValue();
    const product = this.getProduct();
    return this.systemConfigHttpService
      .updateSystemConfiguration(product, brandInfo)
      .pipe(
        tap(() => this.systemConfigService.loadGeneralInformation(product)),
        map(() => true)
      );
  }

  getProduct(): string {
    return this.routeContextService.getProductFromRouteData(this.activatedRoute);
  }
}
